import {connect} from "react-redux";
import DockList from "./DockList";
import {
  dockListEventHandler,
  dockListProps,
  getTitleDockListMoving,
} from "../common-comps/dock";
import {getComputedDockListMovingToday} from "../../selectors/dock";
import {withRouter} from "react-router-dom";

export const DockListMoving = withRouter(connect(
  state => dockListProps(
    state,
    getComputedDockListMovingToday(state),
    getTitleDockListMoving(state)
  ),
  dispatch => dockListEventHandler(dispatch)
)(DockList));
